import { createContext } from 'react'

import { DropzoneVariant } from '../componentStyles/Dropzone.style'
import type { Context as TContext } from './types'
import { _getInputProps, _getRootProps, _noOp } from './utils'

export const contextDefault: TContext = {
  acceptedFiles: [],
  currentVariant: DropzoneVariant.Default,
  dropzoneState: {
    acceptedFiles: [],
    fileRejections: [],
    getInputProps: _getInputProps,
    getRootProps: _getRootProps,
    inputRef: { current: null },
    isDragAccept: false,
    isDragActive: false,
    isDragReject: false,
    isFileDialogActive: false,
    isFocused: false,
    open: _noOp,
    rootRef: { current: null },
  },
  potentialDuplicatePaths: [],
  props: {
    dropzoneProps: {},
    maxFileSize: 1024 * 1024 * 25, // 25MB
    onFileChange: _noOp,
    coverPage: null,
  },
  ref: { current: null },
  fileRejections: [],
  resetAllState: _noOp,
  setCurrentVariant: _noOp,
  totalSize: 0,
  updateFiles: _noOp,
  setFiles: _noOp,
  coverPage: null,
}

export const Context = createContext<TContext>(contextDefault)
